import { TradingOrder, TradingOrderType } from "../config/trading";
import { EditingPosition } from "./editingPosition";
import { EditingOrder } from "./editingOrder";


export class EditingStopOrder extends EditingOrder {
    constructor(pos: EditingPosition, trd: TradingOrder) {
        if (trd.type != TradingOrderType.Stop)
            throw 'not stop order';
        super(pos, trd);
        this.fix = 100;
    }
}
